export default "__VITE_ASSET__9732b62f__"